export const SET_FIELDS = 'app/FieldsSelector/SET_FIELDS';
export const SET_AVAILABLE_FIELDS = 'app/FieldsSelector/SET_AVAILABLE_FIELDS';

export const SET_SELECT_ON_MAP = 'app/FieldsSelector/SET_SELECT_ON_MAP';
